/**
 * Hidden component that makes Odoo settings available in the route context
 * Add this component to your route and fill in the datasource fields
 */
const OdooSettingsProvider = ({ fields }) => {
  // Only run in browser, not during server-side rendering
  if (typeof window !== 'undefined' && fields) {
    window.__ODOO_SETTINGS__ = {
      apiKey: fields.ApiKey?.value || '',
      apiValue: fields.ApiValue?.value || '',
      baseUrl: fields.baseUrl?.value || '',
      country: fields.country?.value || ''
    };
  }
  
  return null; // Hidden component - renders nothing
};

export default OdooSettingsProvider;
